<template>
  <div class="lxm-search">
    <!--<lxm-nav></lxm-nav>-->
    <template v-if="state.showResult">
      <div class="page">
        <template v-if="contacts.length > 0">
          <h2 class="subtitle">联系人</h2>
          <template v-for="item in contacts">
            <lxm-contact-item :avatar="item.avatar"
                              :id="item.id"
                              :org="item.org"
                              :name="item.name"
                              :phone="item.phone"
                              :isFemale="item.isFemale"></lxm-contact-item>
          </template>
        </template>
        <template v-if="orgs.length > 0">
          <h2 class="subtitle">机构</h2>
          <template v-for="item in orgs">
            <lxm-org-item :id="item.id" :name="item.name"></lxm-org-item>
          </template>
        </template>
        <template v-if="cfs.length > 0">
          <h2 class="subtitle">筹款</h2>
          <template v-for="item in cfs">
            <lxm-item :name="item.name"
                      :value="item.value"
                      :update="item.update"
                      :valueSuffix="item.valueSuffix"
                      :to="item.to"></lxm-item>
          </template>
        </template>
        <template v-if="forms.length > 0">
          <h2 class="subtitle">表单</h2>
          <template v-for="item in forms">
            <lxm-item :name="item.name"
                      :value="item.value"
                      :update="item.update"
                      :valueSuffix="item.valueSuffix"
                      :to="item.to"></lxm-item>
          </template>
        </template>
        <template v-if="activities.length > 0">
          <h2 class="subtitle">活动</h2>
          <lxm-activity-item v-for="item in activities"
                             :id="item.id"
                             :title="item.title"
                             :value="item.signedUpUserCount"
                             :valueSuffix="item.valueSuffix"
                             :to="item.to"></lxm-activity-item>
        </template>
      </div>
    </template>
    <template v-else-if="state.showEmpty">
      <div class="lxm-search__content content has-text-centered">
        <p>未搜索到相关结果</p>
      </div>
    </template>
    <template v-else>
      <div class="lxm-search__content content has-text-centered">
        <p>搜索联系人（手机、邮箱）、机构</p>
        <p>筹款、表单、活动...</p>
      </div>
    </template>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../styles/index.styl'
  .lxm-search__content
    font-size: size
    color: grey
    font-weight: bold
    margin-top: siz(95)
    &.content p:not(:last-child)
      margin-bottom: spacing
  .lxm-search
    .subtitle:not(:first-child)
      padding-top: spacing-big - spacing
</style>

<script>
  import LxmNav from './common/LxmNav.vue'
  import LxmOrgItem from './common/LxmOrgItem.vue'
  import LxmContactItem from './common/LxmContactItem.vue'
  import LxmItem from './common/LxmItem.vue'
  import LxmActivityItem from './common/LxmActivityItem.vue'
  import { getCfItems, getFormItems, getActivityItems } from '../../utils'
  import * as aTypes from '../../store/action-types'
  import * as mTypes from '../../store/mutation-types'
  export default {
    components: {
      LxmNav,
      LxmOrgItem,
      LxmContactItem,
      LxmItem,
      LxmActivityItem
    },
    computed: {
      state () {
        return this.$store.state.search
      },
      contacts () {
        return this.state.result.contacts
      },
      orgs () {
        return this.state.result.orgs
      },
      cfs () {
        return getCfItems(this.state.result.cfs)
      },
      forms () {
        return getFormItems(this.state.result.forms)
      },
      activities () {
        return getActivityItems(this.state.result.activities)
      }
    },
    mounted () {
      this.$store.commit(mTypes.SET_NAV_TITLE, '')
      this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '用搜索功能' })
    }
  }
</script>



// WEBPACK FOOTER //
// Search.vue?0b26605e